import React from 'react';
import autoBind from 'react-autobind';
import {withRouter} from 'react-router';
import ClientResultsStore from '../stores/ClientResultsStore';
import ClientResultsActions from '../actions/ClientResultsActions';
import RadioButtonList from '../components/Common/RadioButtonList.jsx';
import Transitions from '../core/Transitions';
import SlidingSessionNotification from './SlidingSessionNotification.jsx';
import OmnitureTracking from '../utils/OmnitureTracking.js';

function getState() {
  return {
    productId: ClientResultsStore.getProductId(),
    searchResult: ClientResultsStore.getSearchResult()
  };
}

class ClientResults extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = getState();
  }

  componentDidMount() {
    ClientResultsStore.addChangeListener(this._onChange);
    OmnitureTracking.getTrackingEnabled();
  }

  componentWillUnmount() {
    ClientResultsStore.removeChangeListener(this._onChange);
  }

  _onChange() {
    this.setState(getState());
  }

  _onClientSelect(event) {
    ClientResultsActions.setClientOin(event.target.value);
    Transitions.forwardFromClientSelect(this.props.router, { productId: this.state.productId });
  }

  render() {
    return (
      <div className="start">
        <div className="container">
          <SlidingSessionNotification />
          <div className="row">
            <div className="col-md-8 col-md-offset-2">
              <RadioButtonList data={this.state.searchResult}
                handleChange={this._onClientSelect}
                id="clientList"
                label="Select client"
                name="clientList"
                useHeadingStyle={true} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ClientResults)


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ClientResults.jsx